module.exports = __webpack_public_path__ + "static/media/banner-novo-robo-lances.8afeb77d.jpg";